import Spinner from "../../../../common/library/loader/Spinner";

const ScreenLoader = (props) => {
    
    const { title, hideLoader } = props;

    return (
        <div className="h-full w-full flex flex-col justify-center items-center gap-4">
            {!hideLoader && <Spinner className="h-12 w-12"/>}
            <span className="text-white font-normal text-lg">{title}</span>
        </div>
    );
}

export default ScreenLoader;